import { useFeature } from 'flagged';
/**
 * Wrapper for useFeature that ensures to return a Boolean.
 *
 * Due to how flagged supports nested feature flags, useFeature
 * might return a FeatureGroup object or a Boolean. If a FeatureGroup is returned,
 * we consider the feature to be disabled, since you most probably passed
 * an incomplete feature identifier.
 */
export var useFeatureFlag = function useFeatureFlag(feature) {
    var result = useFeature(feature);
    return typeof result === 'boolean' ? result : false;
};
